import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';

export class UserAvailability extends BaseEntityModel {
  id?: number;
  userId?: number;
  isUnavailable?: boolean;

  constructor(model: Partial<UserAvailability> = {}) {
    super(model);

    this.id = model.id;
    this.userId = model.userId;
    this.isUnavailable = model.isUnavailable;
  }
}
